import { Link } from "react-router-dom";
import Carregando from "../componentes/Carregando";
import Rodape from "../componentes/Rodape";
import { aberturaDoCard, useHub, type CardVitrine } from "../lib/dados";
import { Aviso, LinkDoCard, SetaDireita, Topo } from "../componentes/ui";

// A página `contrate-um-contador` do app do Bubble (N11, fase 2): um painel com a
// saudação e as duas opções, Área do Candidato e Área do Contratante. Até aqui a
// área da inicial levava a uma seção da própria inicial; agora tem página, como no
// Bubble. Os cards são os de escopo 'conta' (000038): não pertencem a curso, e
// ninguém os compra.
//
// A cara é a do Bubble, com as cores de lá escritas à mão (o fundo #001c41, o
// painel #213653 e o título #ff9b35), e por isso não muda com o tema. A arte de
// fundo do Bubble é essa cor lisa (1728x1117, variação de um nível), então vai a
// cor e não a imagem. As artes dos dois cards saíram do pacote PÚBLICO da página
// (o `static_js` de `/live/contrate-um-contador/`, sem login). Lá os nomes dos
// arquivos estão trocados: o "área-do-candidato" mostra "Área do Contratante".
// Valeu o que a imagem diz.
const IMAGEM_DA_CONTA: Record<string, string> = {
  "area-do-candidato": "/cards/contrate/area-do-candidato.png",
  "area-do-contratante": "/cards/contrate/area-do-contratante.png",
};

export default function ContrateUmContador() {
  const estado = useHub();
  if (estado.fase === "carregando") return <Carregando />;
  if (estado.fase === "erro") {
    return (
      <Aviso titulo="Algo deu errado">
        Não conseguimos carregar o Contrate um Contador agora. Recarregue a página; se continuar
        assim, fale com o suporte.
      </Aviso>
    );
  }

  const hub = estado.fase === "pronto" ? estado.hub : null;
  const cards = hub?.cardsDeConta ?? [];

  return (
    <div className="min-h-screen">
      <Topo atual="inicio" nome={hub?.nome ?? null} avatarUrl={hub?.avatarUrl} />

      <div className="bg-[#001c41] pt-6 pb-16">
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <Link
            to="/"
            className="mb-4 inline-flex items-center gap-2 text-sm font-semibold text-[#c9d3e3] transition hover:text-white"
          >
            <SetaDireita className="size-4 rotate-180" /> Voltar ao início
          </Link>

          <div className="rise flex flex-col items-center gap-8 rounded-2xl bg-[#213653] p-6 sm:p-10 md:flex-row md:justify-between">
            <div className="md:max-w-sm">
              <h1 className="text-3xl font-bold leading-tight text-[#ff9b35] sm:text-4xl">
                Seja bem-vindo(a) ao Contrate um Contador!
              </h1>
              <p className="mt-3 text-lg font-semibold text-white">
                {cards.length > 0 ? (
                  <>
                    Selecione uma das opções <span className="md:hidden">abaixo</span>
                    <span className="hidden md:inline">ao lado</span>:
                  </>
                ) : (
                  "O Contrate um Contador ainda não está disponível para a sua conta."
                )}
              </p>
            </div>
            {cards.length > 0 && (
              <div className="flex flex-wrap justify-center gap-4">
                {cards.map((card, i) => (
                  <CardDaConta key={card.card_slug} card={card} i={i + 1} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-16 sm:px-6">
        <Rodape />
      </div>
    </div>
  );
}

function CardDaConta({ card, i }: { card: CardVitrine; i: number }) {
  // Card de escopo 'conta' não pertence a curso e não tranca por contrato
  // (000046) — daí o curso nulo: quem resolve o escopo é `aberturaDoCard`, com o
  // sentinela 'conta' na ponte.
  const abertura = aberturaDoCard(card, null);
  const imagem = IMAGEM_DA_CONTA[card.card_slug];
  const base = "rise relative block w-36 overflow-hidden rounded-xl sm:w-44";
  const estilo = { "--i": i } as React.CSSProperties;

  // Card sem destino não é link: a ferramenta ainda mora no Bubble (Fase 4), e um
  // link quebrado é pior que um "em breve" honesto. O estado vive SOBRE a arte, e
  // sem o `CARD_EM_BREVE`: a arte tem a borda transparente, e o fundo dele
  // apareceria como um retângulo em volta dela.
  return (
    <LinkDoCard abertura={abertura} className={base} style={estilo}>
      {imagem ? (
        <img src={imagem} alt={card.card_nome} className="block w-full" />
      ) : (
        // Card de conta novo, ainda sem arte: o nome, no mesmo formato.
        <span className="flex aspect-[396/500] items-center justify-center bg-white p-4 text-center font-bold text-[#0b1e42]">
          {card.card_nome}
        </span>
      )}
      {/* O chip da casa muda com o tema e, no escuro, sumia sobre o cinza-claro da
          arte. Card de conta não tranca (000046), então o único estado é "em breve". */}
      {!abertura.abre && (
        <span className="absolute right-3 top-3 inline-flex items-center rounded-full bg-[#0b1e42] px-2.5 py-0.5 text-xs font-semibold text-white">
          Em breve
        </span>
      )}
    </LinkDoCard>
  );
}
